// extracted by mini-css-extract-plugin
export var address = "ContactsModule-module--address--0322f";
export var arrowUpAndDown = "ContactsModule-module--arrow-up-and-down--a027a";
export var contact = "ContactsModule-module--contact--05dff";
export var contactContainer = "ContactsModule-module--contactContainer--d90d7";
export var contactsContainer = "ContactsModule-module--contactsContainer--55098";
export var container = "ContactsModule-module--container--6320f";
export var email = "ContactsModule-module--email--49d6c";
export var phone = "ContactsModule-module--phone--1c8bd";
export var title = "ContactsModule-module--title--047ed";
export var titleContainer = "ContactsModule-module--titleContainer--676db";